// src/pages/BGRemover.js
import React from 'react';
import MiniToolPageLayout from '../components/MiniToolPageLayout';
import BgTool from '../components/BgTool';
import { IoImageOutline } from 'react-icons/io5';

// --- Page-Specific Data ---
const pageData = {
  seo: {
    title: "Free AI Background Remover | Oolook Tools",
    description: "Instantly remove the background from any image with Oolook’s free, AI-powered tool. Perfect for product photos, portraits, and more. No signup required.",
    image: 'https://oolook.in/og/bg-remover.png',
    schemas: [{
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "AI Background Remover",
      "operatingSystem": "All",
      "applicationCategory": "ImageEditing",
      "description": "Oolook’s Background Remover lets you automatically remove the background from any image using artificial intelligence.",
      "url": "https://oolook.in/bg-remover",
      "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
    }]
  },
  hero: {
    icon: IoImageOutline,
    title: "AI Background Remover",
    subtitle: "Instantly remove the background from any image with a single click. Perfect for product photos, portraits, and creative projects."
  },
  // ✅ Add the data for the new guide section
  guide: {
    title: "How It Works",
    subtitle: "Clean, professional cutouts in three simple steps.",
    steps: [
      { title: "1. Upload Your Image", description: "Drag and drop your file onto the canvas, or use the upload button. We support PNG, JPG, and WEBP formats." },
      { title: "2. AI Does the Magic", description: "Our intelligent AI automatically detects the subject and removes the background with pixel-perfect precision in about 3 seconds." },
      { title: "3. Download Your PNG", description: "Your new image with a transparent background is ready. Hit the download button to save your high-resolution PNG file." }
    ]
  }
};

const BGRemover = () => {
  return (
    <MiniToolPageLayout seo={pageData.seo} hero={pageData.hero} guide={pageData.guide}>
      <BgTool />
    </MiniToolPageLayout>
  );
};

export default BGRemover;